import { useEffect, useRef } from "react";
import { useStore } from "react-redux";

const Iframe = (props) => {
  const { className, title, src, query } = props || {};
  const { configStorage } = useStore().getState();
  const htmlRef = useRef();

  useEffect(() => {
    if (htmlRef.current) {
      const defaultApi = configStorage.getApi();
      const template = document.createElement("template");
      defaultApi.getEdelmetallInfo((error, _data, response) => {
        if (!error && response && response.text && htmlRef.current) {
          template.innerHTML = response.text;
          let div = template.content.querySelector(query || "div");
          if (!div && query) div = template.content.querySelector("div");
          if (div) {
            htmlRef.current.innerHTML = "";
            htmlRef.current.appendChild(div);
          }
        } else if (error) {
          htmlRef.current.innerHTML = "Fehler: " + error.message;
        }
      });
    }
  }, [src, htmlRef, query, configStorage]);

  return <div ref={htmlRef} className={"iframe " + className} title={title}></div>;
};
export default Iframe;
